import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=6b762ec4&scoped=true&"
import script from "./ClientInfo.vue?vue&type=script&lang=js&"
export * from "./ClientInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b762ec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b762ec4')) {
      api.createRecord('6b762ec4', component.options)
    } else {
      api.reload('6b762ec4', component.options)
    }
    module.hot.accept("./ClientInfo.vue?vue&type=template&id=6b762ec4&scoped=true&", function () {
      api.rerender('6b762ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/ClientInfo.vue"
export default component.exports